var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"formRef",attrs:{"action":_vm.payment.postUrl,"method":"post","name":"form"}},_vm._l((_vm.payment.parameters),function(value,key){return _c('input',{key:key,attrs:{"type":"hidden","name":key},domProps:{"value":value}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }